export const MAP_ICON_PICKER_SEARCH_ICONS = "MAP_ICON_PICKER_SEARCH_ICONS";
export const MAP_ICON_PICKER_SEARCH_ICONS_RESPONSE = "MAP_ICON_PICKER_SEARCH_ICONS_RESPONSE";